// 全てのリスト要素を取得
const anchorListItems = document.querySelectorAll('.c-anchorList_item');

// 各リスト要素について処理
anchorListItems.forEach(item => {
    // リンク先URLを取得
    const wakatakekaiLink = item.querySelector('.c-anchorList_link').getAttribute('href');
    // 現在のURLとリンク先URLが一致する場合は--isHereクラスを付与
    if (window.location.pathname === wakatakekaiLink) {
        item.classList.add('--isHere');
    }
});
